/* @ngInject */
const editFieldModal = (
  $uibModal,
  wagonRequest,
  $$owner,
  toaster,
  utils
) => {
  const self = {}

  self.open = (_wagon, _fieldName) => {
    return $uibModal.open({
      template: require('./editOwner.html'),
      resolve: {
        wagon: () => {
          return _wagon
        },
        fieldName: () => {
          return _fieldName
        },
      },
      /* @ngInject */
      controller: (
        $scope,
        $uibModalInstance,
        wagonFields,
        wagon,
        fieldName
      ) => {
        $scope.myWagon = wagon
        $scope.fieldName = fieldName
        $scope.fieldsOptions = wagonFields

        // $scope.data = []
        $$owner.request.getAll()
          .then(response => {
            $scope.data = response.owners || []
            $scope.$apply()
          })

        const oldModel = $scope.myWagon[fieldName]

        $scope.submit = async (_fieldName, _fieldValue, _id) => {

          const data = {
            ownerId: _fieldValue,
            id: _id,
          }

          try {
            const response = await wagonRequest.updateOwner(data)
            $scope.myWagon.owner = response.wagon.owner
            $uibModalInstance.close()
          } catch (error) {
            toaster.error(error)
            $scope.myWagon[fieldName] = oldModel
            $uibModalInstance.close()
          }
        }

        $scope.cancel = () => {
          $scope.myWagon[fieldName] = oldModel
          $uibModalInstance.close()
        }
      },
    })
  }

  return self
}
export default editFieldModal



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/wagon/modals/editOwner.modal.js